module.exports = __webpack_public_path__ + "img/Video.c9ef99a3.svg";